import React from 'react'
import {Provider} from 'react-redux'
import {render} from 'react-dom'
import App from './main/App'
import * as serviceWorker from './serviceWorker';
import storeConfig from '../src/store/storeconfig'

import axios from 'axios'
axios.defaults.baseURL='https://vaipescar.firebaseio.com'

const store = storeConfig()

render(
    <Provider store={store}>
        <App/>
    </Provider>, 
    document.getElementById('root')
    )
serviceWorker.register();